import type { ReactNode } from 'react'
import { Page } from '@dhl/page'
import { Language } from '@dhl/i18n'
import { userLanguages } from '~/i18n'

type Props = {
  children?: ReactNode
  isLoading: boolean
  testId?: string
}

export const BasePage = (props: Props) => (
  <Page {...props} isReloadable={false} headerContent={<Language locales={userLanguages()} />} />
)
